(function () {
  function init(section) {
    if (section.dataset.dtCreatorReady === 'true') return;
    var choices = Array.from(section.querySelectorAll('[data-dt-creator-choice]'));
    var media = section.querySelector('[data-dt-creator-media]');
    var play = section.querySelector('[data-dt-creator-play]');
    var title = section.querySelector('[data-dt-creator-title]');
    var author = section.querySelector('[data-dt-creator-author]');
    if (!choices.length || !media || !play || !title || !author) return;
    section.dataset.dtCreatorReady = 'true';

    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        choices.forEach(function (item) {
          var selected = item === choice;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        var iframe = media.querySelector('iframe');
        if (iframe) iframe.remove();
        play.hidden = false;
        play.dataset.embed = choice.dataset.embed;
        play.dataset.title = choice.dataset.title;
        play.setAttribute('aria-label', play.dataset.playLabel + ': ' + choice.dataset.title);
        play.querySelector('img').src = choice.dataset.thumbnail;
        title.textContent = choice.dataset.title;
        author.textContent = choice.dataset.creator;
      });
    });

    play.addEventListener('click', function () {
      var url;
      try { url = new URL(play.dataset.embed); } catch (error) { return; }
      if (url.hostname !== 'www.youtube.com' && url.hostname !== 'youtube.com' && url.hostname !== 'www.youtube-nocookie.com') return;
      if (!/^\/embed\/[A-Za-z0-9_-]{11}$/.test(url.pathname)) return;
      url.searchParams.set('autoplay', '1');
      url.searchParams.set('rel', '0');
      var iframe = document.createElement('iframe');
      iframe.src = url.toString();
      iframe.title = play.dataset.title;
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      play.hidden = true;
      media.appendChild(iframe);
    });
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-dt-creator]')) init(scope);
    scope.querySelectorAll('[data-dt-creator]').forEach(init);
  }

  function boot() {
    scan(document);
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
